import React from 'react';
import { SwapHorizontalIcon } from '@clearcover/atlas';
import styles from './styles.module.css';

function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(value);
}

interface PremiumChangeProps {
  label?: string;
  oldValue: number;
  newValue: number;
  delta?: number;
}

const PremiumChange: React.FC<PremiumChangeProps> = ({
  label,
  oldValue,
  newValue,
  delta,
}) => {
  const displayDelta = delta !== undefined ? delta : newValue - oldValue;
  const sign = displayDelta > 0 ? '+' : '';
  const deltaClassName =
    displayDelta > 0
      ? styles.premiumChangeDeltaPositive
      : displayDelta < 0
        ? styles.premiumChangeDeltaNegative
        : styles.premiumChangeDeltaNeutral;

  return (
    <div className={styles.premiumChange}>
      {label && <div className={styles.premiumChangeLabel}>{label}</div>}
      <div>
        {formatCurrency(oldValue)}{' '}
        <SwapHorizontalIcon
          aria-hidden="true"
          style={{ width: 16, height: 16, verticalAlign: 'middle' }}
        />{' '}
        {formatCurrency(newValue)}{' '}
        <span className={deltaClassName}>
          ({sign}
          {formatCurrency(displayDelta)})
        </span>
      </div>
    </div>
  );
};

export default PremiumChange;
